module.exports = __webpack_public_path__ + "img/monarch-logo-white-stacked.bd2e2757.png";